import cuesheetHoc from 'main/components/show/cuesheet/cuesheet.hoc';
import { ViewTypes } from 'shared/constants/CuesheetViews';

export default cuesheetHoc(ViewTypes.Compact);
